

import { useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";

const Textos = () => {
    

    

  return (
    <>
     
    </>
  );
};

export default Textos;
